"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/** @module path */ /** for typedoc */
__export(require("./pathNode"));
__export(require("./pathFactory"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uirouter/core/lib/path/index.js
// module id = 399
// module chunks = 1